module.exports = __webpack_public_path__ + "img/internet.e8c526d3.png";